<template>
  <div class="upoladSuccessStyle">
    <div class="uploadInvoiceStyle">
      <InvoiceComponent :invoiceData="invoiceData" />
    </div>
    <div class="footerButtonBox">
      <FooterTwoButton
        :leftNext="goback"
        :rightNext="continueUploadFc"
        left="返回"
        right="继续上传"
        :repay='repay'
      ></FooterTwoButton>
    </div>
  </div>
</template>
<script>
import InvoiceComponent from '@/components/invoice/index.vue';
import { continueUpload } from '@/utils/invoiceCheck';
import FooterTwoButton from './FooterTwoButton.vue';

export default {
  name: 'upoladSuccess',
  data() {
    return {
      invoiceData: {},
      repay: true,
      type: '',
    };
  },
  created() {
    const mate = document.querySelector('meta[name=viewport]');
    mate.setAttribute('content', 'width=device-width,initial-scale=0.5,minimum-scale=0.5,maximum-scale=1,user-scalable=yes');
  },
  computed: {
  },
  methods: {
    goback() {
      window.location.href = '/supermarket/v2/uploadTicket';
    },
    continueUploadFc() {
      console.log('this.type===', this.type);
      continueUpload(this.type);
      console.log('我点击了重新上传');
    },
  },
  watch: {
    '$route.query.time': {
      handler(n) {
        const RouterData = this.$router.currentRoute.query;
        this.type = RouterData.type;
        this.invoiceData = RouterData.data ? JSON.parse(RouterData.data) : {};
      },
      immediate: true,
    },
  },
  components: {
    InvoiceComponent,
    FooterTwoButton,
  },
};
</script>
<style  scoped>
.upoladSuccessStyle {
  padding-top: 10px;
}
</style>
